import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from './components/ScrollEffects/ScrollToTp';
import PageNotFound from './pages/PageNotFound/PageNotFound';
import TheLayout from './common/MainLayout/TheLayout';
import Home from './pages//Home/Home';
import AboutUs from './pages//AboutUs/AboutUs';
import TermsAndConditions from './pages/CMS/TermsAndConditions';
import KeyFeatures from './pages/CMS/KeyFeatures';
import './App.scss';
import './style.scss';
import './responsive.scss';
import PrivacyPolicy from './pages/CMS/PrivacyPolicy';
import HelpAndSupport from './pages/CMS/HelpAndSupport';
import DeleteAccount from './pages/CMS/DeleteAccount';
import DataReset from './pages/CMS/DataReset';





function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>

          {/* PageNotFound */}
          <Route path="*" element={<PageNotFound />} />


          {/* Pages */}
          <Route path='/' element={<TheLayout />}>
          <Route path="/" element={<Home />} exact />
            <Route path="/home" element={<Home />} exact />
            <Route path="/about-us" element={<AboutUs />} exact />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} exact />
            <Route path="/Key-features" element={<KeyFeatures />} exact />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} exact />
            <Route path="/help-and-support" element={<HelpAndSupport />} exact />
            <Route path="/delete-account" element={<DeleteAccount />} exact />
            <Route path="/data-reset" element={<DataReset />} exact />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
